module.exports = {
	"ha": "iha",
	"id": 5.3,
	"report": {
		"ha": "Interior Health",
		"group": "HSDA",
		"period": "2018 Q3–2020 Q2",
		"lastYear": "2020",
		"lastQuarter": "2"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 60,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.3</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Interior Health by Age Category, Year Ending 2020 Q2 <sup style=\"font-size: 10px;\">8</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -130,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 90,
						"dataLabels": {
							"enabled": true,
							"format": "27",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 73.33333333333333,
						"dataLabels": {
							"enabled": true,
							"format": "22",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 73.33333333333333,
						"dataLabels": {
							"enabled": true,
							"format": "22",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 66.66666666666666,
						"dataLabels": {
							"enabled": true,
							"format": "20",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 40,
						"dataLabels": {
							"enabled": true,
							"format": "12",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": true,
							"format": "70",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 84.28571428571429,
						"dataLabels": {
							"enabled": true,
							"format": "59",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 81.42857142857143,
						"dataLabels": {
							"enabled": true,
							"format": "57",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 74.28571428571429,
						"dataLabels": {
							"enabled": true,
							"format": "52",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 47.14285714285714,
						"dataLabels": {
							"enabled": true,
							"format": "33",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": true,
							"format": "133",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 82.70676691729322,
						"dataLabels": {
							"enabled": true,
							"format": "110",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 80.45112781954887,
						"dataLabels": {
							"enabled": true,
							"format": "107",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 72.18045112781954,
						"dataLabels": {
							"enabled": true,
							"format": "96",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 42.10526315789473,
						"dataLabels": {
							"enabled": true,
							"format": "56",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": true,
							"format": "433",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 83.37182448036951,
						"dataLabels": {
							"enabled": true,
							"format": "361",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 80.83140877598153,
						"dataLabels": {
							"enabled": true,
							"format": "350",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 76.905311778291,
						"dataLabels": {
							"enabled": true,
							"format": "333",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 51.73210161662818,
						"dataLabels": {
							"enabled": true,
							"format": "224",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -9.999999999999998,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -18.518518518518523,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -9.090909090909093,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -40,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -15.714285714285714,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -3.3898305084745783,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -8.771929824561408,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -36.53846153846154,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -17.29323308270677,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -2.7272727272727226,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -10.280373831775702,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -41.666666666666664,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -16.628175519630485,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -3.0470914127423865,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -4.857142857142859,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -32.73273273273273,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "< 30<br>n=30"
			},
			{
				"x": 9,
				"text": "30–39<br>n=70"
			},
			{
				"x": 15,
				"text": "40–49<br>n=133"
			},
			{
				"x": 21,
				"text": "≥ 50<br>n=433"
			}
		],
		"dataTable": {
			"< 30": [
				30,
				27,
				22,
				22,
				20,
				12
			],
			"30–39": [
				70,
				70,
				59,
				57,
				52,
				33
			],
			"40–49": [
				133,
				133,
				110,
				107,
				96,
				56
			],
			"≥ 50": [
				433,
				433,
				361,
				350,
				333,
				224
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_iha_5_3.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_iha_5_3.json
// module id = 236
// module chunks = 0